import React, { Context, useContext } from 'react';
import { NavigateProps, Outlet, Navigate as Redirect, RouteProps } from 'react-router-dom';

type FunctionType = () => any;

interface PrivateRouteUsignContext<T> {
  context: Context<T>;
  accessWith: (context: T) => boolean;
  otherwiseRedirectTo?: FunctionType | NavigateProps;
}

export default function createPrivateRouteUsignContext<T>({
  context,
  accessWith,
  otherwiseRedirectTo = { to: '/' },
}: PrivateRouteUsignContext<T>): React.FC<RouteProps> {
  return function PrivateRoute() {
    const ctx = useContext(context);

    if (accessWith(ctx)) {
      return <Outlet />;
    }

    if (typeof otherwiseRedirectTo === 'function') {
      return otherwiseRedirectTo();
    }

    return <Redirect {...otherwiseRedirectTo} replace />;
  };
}
